import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import type { SearchFilterStrategy } from 'lib-search-types';

import { useSearchFilters } from '../../searchFilters.context';
import { filterStrategyAssets } from '../../utils/definitions';

/** Represents a dropdown component that is used to select a filtering strategy */
export const FilterStrategy = (): JSX.Element => {
  const { strategy, updateStrategy } = useSearchFilters();
  const strategies: SearchFilterStrategy[] = ['all', 'any'];

  return (
    <DropdownButton
      buttonProps={{ variant: 'tertiary' }}
      fixed
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              {strategies.map((item) => (
                <ButtonList.Item
                  key={item}
                  isSelected={item === strategy}
                  onClick={() => {
                    updateStrategy(item);
                    toggleDropdown();
                  }}
                >
                  {filterStrategyAssets[item].description}
                </ButtonList.Item>
              ))}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    >
      {filterStrategyAssets[strategy].label}
    </DropdownButton>
  );
};
